/**
 * Organizer event calculator (spec 007).
 * Estimates shirts, printing budget, funding target, and a sponsor-tier mix
 * from editable inputs. Informational only — real quantities and pricing are
 * confirmed manually during campaign setup.
 */
(function () {
  'use strict';

  var LADDERS = [
    { name: 'Small', maxShirts: 100, prices: { title: 1000, gold: 500, silver: 250, bronze: 100 } },
    { name: 'Medium', maxShirts: 400, prices: { title: 1500, gold: 700, silver: 350, bronze: 150 } },
    { name: 'Large', maxShirts: Infinity, prices: { title: 2500, gold: 1200, silver: 600, bronze: 250 } }
  ];

  function formatMoney(amount) {
    return '$' + Math.round(amount).toLocaleString('en-CA');
  }

  function suggestShirts(attendance) {
    if (!attendance || attendance <= 0) return 0;
    var suggested = Math.round((attendance * 0.25) / 5) * 5;
    return Math.max(30, suggested);
  }

  function pickLadder(shirts) {
    for (var i = 0; i < LADDERS.length; i++) {
      if (shirts <= LADDERS[i].maxShirts) return LADDERS[i];
    }
    return LADDERS[LADDERS.length - 1];
  }

  function suggestMix(target, prices) {
    var titleCount = Math.max(1, Math.floor((target * 0.25) / prices.title));
    var goldCount = Math.ceil((target * 0.25) / prices.gold);
    var silverCount = Math.ceil((target * 0.25) / prices.silver);
    var raised = titleCount * prices.title + goldCount * prices.gold + silverCount * prices.silver;
    var bronzeCount = Math.max(0, Math.ceil((target - raised) / prices.bronze));
    raised += bronzeCount * prices.bronze;
    return {
      title: titleCount,
      gold: goldCount,
      silver: silverCount,
      bronze: bronzeCount,
      raised: raised,
      sponsors: titleCount + goldCount + silverCount + bronzeCount
    };
  }

  function initCalculator(root) {
    var attendanceInput = root.querySelector('[data-calc-input="attendance"]');
    var shirtsInput = root.querySelector('[data-calc-input="shirts"]');
    var costInput = root.querySelector('[data-calc-input="cost"]');
    var outputs = {
      printing: root.querySelector('[data-calc-output="printing"]'),
      target: root.querySelector('[data-calc-output="target"]'),
      ladder: root.querySelector('[data-calc-output="ladder"]'),
      mix: root.querySelector('[data-calc-output="mix"]'),
      mixSummary: root.querySelector('[data-calc-output="mix_summary"]')
    };
    if (!attendanceInput || !shirtsInput || !costInput) return;

    var shirtsEdited = false;

    function update() {
      var attendance = parseFloat(attendanceInput.value) || 0;
      if (!shirtsEdited) {
        shirtsInput.value = suggestShirts(attendance) || '';
      }
      var shirts = parseFloat(shirtsInput.value) || 0;
      var cost = parseFloat(costInput.value) || 0;

      var printing = shirts * cost;
      var target = printing > 0 ? Math.ceil((printing * 2.5) / 500) * 500 : 0;
      var ladder = pickLadder(shirts);
      var p = ladder.prices;

      outputs.printing.textContent = formatMoney(printing);
      outputs.target.textContent = formatMoney(target);
      outputs.ladder.textContent =
        ladder.name + ' — ' + formatMoney(p.bronze) + ' / ' + formatMoney(p.silver) + ' / ' + formatMoney(p.gold) + ' / ' + formatMoney(p.title);

      if (target > 0) {
        var mix = suggestMix(target, p);
        var parts = [];
        if (mix.title) parts.push(mix.title + ' Title');
        if (mix.gold) parts.push(mix.gold + ' Gold');
        if (mix.silver) parts.push(mix.silver + ' Silver');
        if (mix.bronze) parts.push(mix.bronze + ' Bronze');
        outputs.mix.textContent = parts.join(' + ');
        outputs.mixSummary.textContent =
          mix.sponsors + ' sponsors raise ~' + formatMoney(mix.raised);
      } else {
        outputs.mix.textContent = '—';
        outputs.mixSummary.textContent = 'Enter your event details above.';
      }
    }

    attendanceInput.addEventListener('input', update);
    shirtsInput.addEventListener('input', function () {
      shirtsEdited = shirtsInput.value !== '';
      update();
    });
    costInput.addEventListener('input', update);

    update();
  }

  function init() {
    document.querySelectorAll('[data-organizer-calculator]').forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
